import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import useGetAgencyInquiryThreads from "@/features/inquiries/hooks/useGetAgencyInquiryThreads";

// GNB 문의/답변 메뉴의 안 읽은 문의 개수 배지. 0이거나 로딩·에러면 숨긴다.
function InquiryNavCountBadge() {
  const { data } = useGetAgencyInquiryThreads({ pageSize: 1 });
  const unreadCount = data?.unread_count ?? 0;

  if (unreadCount <= 0) {
    return null;
  }

  return (
    <Flex
      minWidth={"20px"}
      height={"20px"}
      padding={"0 6px"}
      borderRadius={"full"}
      background={"#FF6B35"}
      alignItems={"center"}
      justifyContent={"center"}
      flexShrink={0}
    >
      <Text
        textStyle={"caption-bold"}
        color={"#FFFFFF"}
        lineHeight={1}
        sx={{ textBox: "trim-both cap alphabetic" }}
      >
        {unreadCount > 99 ? "99+" : unreadCount}
      </Text>
    </Flex>
  );
}

export default InquiryNavCountBadge;
